module.exports = __webpack_public_path__ + "static/oszczednosci-5641ff35d2f2f36b1c97e8d0a990c9b4.jpg";